import { OrderSetResponse } from "../../models/OrderSetModels";
import { OrderTemplate } from "../../models/PatientModels";
import OrderSetMedicationCard from "./OrderSetMedicationCard";

const OrderSetsView = (
    { handleFunction, className = '', isAdminView=false, orderSet }: 
    { orderSet: OrderSetResponse, isAdminView?: boolean, className?: string, handleFunction: (orderSetId: string, templateId: string) => void; }) => {
    return (
        <div>
            {
                orderSet.orderTemplates?.length >= 1 ?
                    <div className="d-grid w-100 pt-4 gap-5"
                    style={{
                        gridTemplateColumns: 'repeat(3, minmax(22em, 1fr))',
                    }}>
                        {orderSet.orderTemplates.map((ot) => (
                            <OrderSetMedicationCard medication={ot} isAdminView={isAdminView} handleFunction={() => handleFunction(orderSet.id, ot.id)} isSelected={ot.isSelected} />
                        ))}
                    </div>
                    :
                    <div className="d-flex align-items-center justify-content-center fs-5 text-light-gray m-5">No medications have been added to this Comfort Kit/Order Set yet.</div>
            }
        </div>
        
        
    );
};

export default OrderSetsView;
